import React from 'react';
import ReactDOM from 'react-dom';
import renderHTML from 'react-render-html';
import moment from 'moment-timezone';
import { saveAs } from 'file-saver';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import stripTags from "striptags";
import { committeeActionCreators } from '../../../stores/lis-committee-store';
import { memberActionCreators } from '../../../stores/lis-members-store';
import { billActionCreators } from '../../../stores/lis-legislation-store';
import { sessionActionCreators } from '../../../stores/lis-session-store';
import { patronActionCreators } from '../../../stores/lis-patron-store';
import { voteActionCreators } from '../../../stores/lis-votes-store';
import { collectionActionCreators } from '../../../stores/lis-collection-store';
import { reportActionCreators } from "../../../stores/lis-report-store";
import { personnelActionCreators } from '../../../stores/lis-personnel-store';
import { Link } from 'react-router-dom';
import * as Excel from "exceljs";

import ShareReport from './share-report'
import { CsvHelpModal } from '../../../services/modal-service';

const BILL_COLLECTION_AUTHOR = "LegislationCollections";
const STAFF = "STAFF";
const CLERKS = "CLERKS";

const MAX_BILL_HISTORY_CHUNK_SIZE = 125;

const weights = {
    "Committee": 1,
    "Subcommittee": 2,
    "recent": 3,
    "all": 4
}
const sortBillHistoryTypes = (typeA, typeB) => {
    return weights[typeA] - weights[typeB];
}

class ReportMaker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showCatchline: true,
            showCurrentStatus: true,
            showTitle: false,
            showChiefPatron: false,
            showAllPatrons: false,
            showSummary: false,
            selectedNotes: 'all',
            showHistory: false,
            showHouseAmendments: false,
            showSenateAmendments: false,
            showConferenceAmendments: false,
            showGovernorsRecommendations: false,
            showStatus: {},
            showCommitteeEvent: {},
            showLdNumber: false,
            showClerkNames: false,
            showDlsStaffNames: false,
            billData: [],
            billList: [],
            collections: [],
            committeeClerksAndStaff: [],
            generatingBillNumbers: true,
            generatingReport: true,
            hbCount: 0,
            hjCount: 0,
            sbCount: 0,
            sjCount: 0,
            showTooltip: false,
            compositeSortValue: "LegislationNumberAsc",
            showNotes: true,
        };
        this.getReportData = this.getReportData.bind(this);
        this.makeHtml = this.makeHtml.bind(this);
        this.makePrintout = this.makePrintout.bind(this);
        this.toggleShareForm = this.toggleShareForm.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.getBillHistoryTypeLabel = this.getBillHistoryTypeLabel.bind(this);
        this.toggleShowNotes = this.toggleShowNotes.bind(this);
        this.generateXLSX = this.generateXLSX.bind(this);

        this.reportData = React.createRef();
        this.htmlRef = React.createRef();
        this.printOutRef = React.createRef();
    }

    async getCommitteeClerksOrStaff(bill, sessionStartDate, role) {
        if (role === STAFF) {
            bill.loadingStaffNames = true;
        } else {
            bill.loadingClerkNames = true;
        }
        this.props.actions.getPersonnelList("staffroletypeid=" + role === STAFF ? this.state.staffRoleTypeID : this.state.clerkRoleTypeID + "&affiliationID=" + bill.CommitteeID + "&effectiveBeginDate=" + sessionStartDate, true)
            .then(() => {
                let committeeClerksAndStaff = [...this.state.committeeClerksAndStaff];
                let personnelList = role === STAFF ? this.props.personnel.personnelStaffList : this.props.personnel.personnelClerkList;
                personnelList.forEach(p => {
                    p.SessionID = bill.SessionID
                })
                committeeClerksAndStaff = committeeClerksAndStaff.concat(personnelList);
                this.setState({ committeeClerksAndStaff })
            })
        if (role === STAFF) {
            bill.loadingStaffNames = false;
        } else {
            bill.loadingClerkNames = false;
        }
    }

    async getLdNumber(bill, versions) {
        bill.loadingLdNumber = true;
        if (!versions) {
            const params = '?BillNumber=' + bill.LegislationNumber + '&sessionID=' + bill.SessionID;
            await this.props.actions.getBillVersionByBillNumber(params).then(async () => {
                versions = this.props.bills.billVersion || [];
            })
        }
        const fullTextVersions = versions.filter(v => v.IsActive && ["Engrossed", "Reengrossed", "Enrolled", "Reenrolled", "Chaptered", "Governor's Veto", "Introduced", "Substitute"].includes(v.Version));
        const latestFullTextVersion = fullTextVersions.length ? fullTextVersions.reduce(function (r, a) {
            return r.DraftDate > a.DraftDate ? r : a;
        }) : null;
        bill.LdNumber = latestFullTextVersion ? latestFullTextVersion.LDNumber : null;
        bill.loadingLdNumber = false;
    }

    async getAmendments(bill) {
        bill.loadingAmendments = true;
        const params = '?BillNumber=' + bill.LegislationNumber + '&sessionID=' + bill.SessionID;
        await this.props.actions.getBillVersionByBillNumber(params).then(async () => {
            if (this.state.showLdNumber) {
                bill.LdNumber = this.getLdNumber(bill);
            }
            bill.amendments = [];
            const amendments = this.props.bills.billVersion.filter(version => {
                if (version.Version.includes('Amendment') && ((this.state.showHouseAmendments && version.ChamberCode === 'H') || (this.state.showSenateAmendments && version.ChamberCode === 'S'))) {
                    return true;
                } else if (version.Version.includes('Conference') && this.state.showConferenceAmendments) {
                    return true;
                } else if (version.Version.includes('Recommendation') && this.state.showGovernorsRecommendations) {
                    return true;
                }
                return false;
            });
            for (let i = 0; i < amendments.length; i++) {
                await this.props.actions.getBillText('?isPublic=true&legislationTextID=' + amendments[i].LegislationTextID)
                    .then(() => {
                        if (this.props.bills.billText !== 0) {
                            bill.amendments.push(this.props.bills.billText[0]);
                        }
                    })
            }
            bill.loadingAmendments = false;
            return Promise.resolve();
        }).catch(err => {
            bill.loadingAmendments = false;
            return Promise.reject(err);
        });
    }

    async getBillHistory(bills) {
        const { showHistory } = this.state;
        let legislationIDs = "";
        bills.forEach((bill, i) => {
            bill.loadingHistory = true;
            legislationIDs += `${i === 0 ? '?' : '&'}legislationIDs=${bill.LegislationID}`;
        })
        await this.props.actions.getBillHistoryByBillID(legislationIDs)
            .then(async () => {
                const allResults = this.props.bills.billHistory;
                for (const bill of bills) {
                    let results = allResults.filter(b => b.LegislationID === bill.LegislationID);

                    let billHistory = {};
                    if (showHistory.recent) {
                        if (results.length > showHistory.mostRecentAmount) {
                            billHistory.recent = results.slice(results.length - parseInt(showHistory.mostRecentAmount || 0));
                        } else {
                            billHistory.recent = results;
                        }
                    } else if (showHistory.all) {
                        billHistory.all = results;
                    }
                    if (showHistory.Committee || showHistory.Subcommittee) {
                        results.forEach(historyItem => {
                            if (historyItem.CommitteeName && !historyItem.ParentCommitteeName && showHistory.Committee) {
                                billHistory.Committee = [historyItem];
                            } else if (historyItem.ParentCommitteeName && showHistory.Subcommittee) {
                                billHistory.Subcommittee = [historyItem];
                            }
                        });
                    }
                    let committeeEvents = {};
                    results.forEach(historyItem => {
                        if (!committeeEvents.firstSenateCommitteeEvent && historyItem.ChamberCode === "S" && historyItem.Status === "In Committee") {
                            committeeEvents.firstSenateCommitteeEvent = historyItem;
                        }
                        if (!committeeEvents.firstHouseCommitteeEvent && historyItem.ChamberCode === "H" && historyItem.Status === "In Committee") {
                            committeeEvents.firstHouseCommitteeEvent = historyItem;
                        }
                        if (historyItem.ChamberCode === "S" && historyItem.Status === "In Subcommittee") {
                            committeeEvents.lastSenateSubcommitteeEvent = historyItem;
                        }
                        if (historyItem.ChamberCode === "H" && historyItem.Status === "In Subcommittee") {
                            committeeEvents.lastHouseSubcommitteeEvent = historyItem;
                        }
                    });
                    bill.committeeEvents = committeeEvents;
                    bill.billHistory = billHistory;
                    bill.loadingHistory = false;
                    if (showHistory.showVotes) {
                        //Can't use a foreach function right here because async will not work since foreach takes a function.
                        // Await doesn't work as it ... waits for the fetch to finish before moving on to the next iteration.
                        for (let i = 0; i < results.length; i++) {
                            if (results[i].VoteID) {
                                this.getVoteDetails(results, i)
                                    .then(() => this.forceUpdate())
                            }
                        }
                    }
                };
                return Promise.resolve()
            }).catch(err => { bills.map(bill => bill.loadingHistory = false); Promise.reject(err) });
    }

    async getVoteDetails(billHistory, i) {
        billHistory[i].loadingVotes = true;
        await this.props.actions.getVoteDetails('?voteID=' + billHistory[i].VoteID)
            .then(() => {
                const voteData = this.props.votes.voteDetailsResponse[0];
                let voteDetails = {};
                voteDetails.ChamberCode = voteData.ChamberCode;
                voteDetails.VoteType = voteData.VoteType;
                voteDetails.memberYeas = voteData.VoteMember.filter(nObj => nObj.ResponseCode === 'Y');
                voteDetails.memberNays = voteData.VoteMember.filter(nObj => nObj.ResponseCode === 'N');
                voteDetails.memberAbstentions = voteData.VoteMember.filter(nObj => nObj.ResponseCode === 'A');
                voteDetails.memberNoVote = voteData.VoteMember.filter(nObj => nObj.ResponseCode === 'X');
                voteDetails.voteStatements = voteData.SessionCode <= 20251 ? voteData.VoteMember.filter(member => member.VoteStatement) : voteData.voteStatements;
                // Abstentions appear as rule 36 on senate floor tally sheets
                if (voteData.ChamberCode === "S" && voteData.VoteType === "Floor") {
                    voteDetails.memberRule36 = voteData.VoteMember.filter(nObj => nObj.ResponseCode === 'A');
                } else {
                    voteDetails.memberRule36 = voteData.VoteMember.filter(nObj => nObj.ResponseCode === 'R');
                }
                billHistory[i].voteDetails = voteDetails;
                billHistory[i].loadingVotes = false;
                return Promise.resolve()
            }).catch(err => {
                billHistory[i].loadingVotes = false;
                return Promise.reject(err);
            });
    }

    async getPatrons(bill) {
        bill.loadingPatrons = true;
        await this.props.actions.getPatronList(bill.LegislationID)
            .then(() => {
                bill.Patrons = this.props.patrons.patronList
                bill.loadingPatrons = false;
                return Promise.resolve
            }).catch(err => { bill.loadingPatrons = false; Promise.reject(err) });
    }

    async getBillStatusHistory(bill) {
        bill.loadingStatusHistory = true;
        let body = { "LegislationIDs": [{ "LegislationID": bill.LegislationID }] }
        await this.props.actions.getBillStatusHistory(body)
            .then(() => {
                bill.billStatuses = this.props.bills.legislationStatusHistory[0]
                bill.loadingStatusHistory = false;
                return Promise.resolve
            }).catch(err => { bill.loadingStatusHistory = false; Promise.reject(err) });
    }

    async getWatchlists(params) {
        await this.props.actions.getCollections(params)
            .then(() => {
                this.setState({
                    collections: this.props.collection.collections
                }, () => {
                    return Promise.resolve()
                })
            }).catch(err => Promise.reject(err));
    }

    getReportData() {
        const { showTitle, showChiefPatron, showAllPatrons, showNotes, userCreated, showHistory, showHouseAmendments, showSenateAmendments, showConferenceAmendments, showGovernorsRecommendations, showStatus, showCommitteeEvent, showLdNumber, showClerkNames, showDlsStaffNames, selectedCollection, billList, sharedNotes, notes } = this.state;
        const params = {
            LegislationNumbers: [{ LegislationNumber: billList.map(bill => bill.LegislationNumber).join() }],
            SessionID: billList[0].SessionID
        };
        this.setState({
            sbCount: billList.filter(bill => bill.LegislationNumber.includes('SB')).length,
            sjCount: billList.filter(bill => bill.LegislationNumber.includes('SJ')).length,
            hbCount: billList.filter(bill => bill.LegislationNumber.includes('HB')).length,
            hjCount: billList.filter(bill => bill.LegislationNumber.includes('HJ')).length
        });
        this.props.actions.getBillList(params).then(() => {
            this.setState({
                generatingBillNumbers: false
            })
            let committeePromises = [];
            let patronPromises = [];
            let historyPromises = [];
            let textPromises = [];
            let statusHistoryPromises = [];
            let billData = this.props.bills.billList;
            //Filter to only one result per bill per session since DB sometimes returns duplicates
            billData = billData.filter((item, pos) => billData.findIndex(i => i.LegislationNumber === item.LegislationNumber && i.SessionID === item.SessionID) === pos);
            //The backend will return the requested bill numbers in alphanumeric order, regardless of the bill number order in the request
            //With that in mind, if the report is created from within bill search, the list of bill numbers stored in the report & sent in the request above will be sorted alphanumerically, so the backend sort is the same and desired
            //If coming from a calendar, however, the list of bill numbers will initially be sorted in calendar order, which is desired, but the api will return the bills alphanumerically
            //That said, the initial bill number order (stored in the report object) is always the proper order, so we need to sort the response back to that
            billData.sort((a, b) => billList.findIndex(l => l.LegislationNumber === a.LegislationNumber && l.SessionID === a.SessionID) - billList.findIndex(l => l.LegislationNumber === b.LegislationNumber && l.SessionID === b.SessionID))
            let showStatusBool = false;
            for (const key in showStatus) {
                if (showStatus[key] === true && key !== "showEmergency") {
                    showStatusBool = true;
                }
            }
            let showCommitteeEventBool = false;
            for (const key in showCommitteeEvent) {
                if (showCommitteeEvent[key] === true) {
                    showCommitteeEventBool = true;
                }
            }
            this.setState({
                billData,
                gettingBillHistory: showHistory || showCommitteeEventBool ? true : false,
                gettingBillStatusHistory: showStatusBool ? true : false,
                gettingClerkNames: showClerkNames ? true : false,
                gettingStaffNames: showDlsStaffNames ? true : false,
                gettingPatrons: showAllPatrons ? true : false,
                gettingVotes: showHistory && showHistory.showVotes ? true : false,
                gettingLdNumbers: showLdNumber ? true : false,
                gettingAmendments: showHouseAmendments || showSenateAmendments || showConferenceAmendments || showGovernorsRecommendations ? true : false
            }, () => {
                let watchlistPromise = null;
                if (showNotes && !!this.props.login.userProfile.email && this.props.login.userProfile.email === userCreated) {
                    watchlistPromise = this.getWatchlists("?SessionID=" + billList[0].SessionID);
                } else {
                    watchlistPromise = new Promise(resolve => resolve());
                }
                watchlistPromise.then(() => {
                    if (showClerkNames || showDlsStaffNames) {
                        this.props.actions.getRoleTypes()
                            .then(() => {
                                const clerkRoleType = this.props.personnel.roleTypes.find(x => x.Name.toLowerCase() === 'committee clerk')
                                const clerkRoleTypeID = clerkRoleType ? clerkRoleType.StaffRoleTypeID : 0;
                                const staffRoleType = this.props.personnel.roleTypes.find(x => x.Name.toLowerCase() === 'committee staff')
                                const staffRoleTypeID = staffRoleType ? staffRoleType.StaffRoleTypeID : 0;
                                this.setState({ clerkRoleTypeID, staffRoleTypeID }, () => {
                                    this.props.actions.getSessionList().then(() => {
                                        let committeesAndSessionsToSearch = [];
                                        const sessionList = this.props.session.sessionList;
                                        billData.forEach(b => {
                                            if (b.CommitteeID && b.SessionID && !committeesAndSessionsToSearch.find(c => c.CommitteeID === b.CommitteeID && c.SessionID === b.SessionID)) {
                                                committeesAndSessionsToSearch.push({ CommitteeID: b.CommitteeID, SessionID: b.SessionID });
                                                if (showClerkNames) {
                                                    committeePromises.push(this.getCommitteeClerksOrStaff(b, sessionList.find(sl => sl.SessionID === b.SessionID).SessionEvents.find(se => se.EventTypeID === 1).ActualDate, CLERKS));
                                                }
                                                if (showDlsStaffNames) {
                                                    committeePromises.push(this.getCommitteeClerksOrStaff(b, sessionList.find(sl => sl.SessionID === b.SessionID).SessionEvents.find(se => se.EventTypeID === 1).ActualDate, STAFF));
                                                }
                                            }
                                        })
                                    })
                                })
                            })
                    }
                    let billHistoryChunks = [];
                    billData.forEach(bill => {
                        bill['Chief Patron'] = bill.Patrons;
                        if (showAllPatrons) {
                            patronPromises.push(this.getPatrons(bill));
                        } else {
                            patronPromises.push(() => Promise.resolve());
                        }
                        bill.Notes = [];
                        if (showStatus.showEmergency) {
                            bill.Emergency = bill.EffectiveType === 'Emergency' ? "Y" : "N"
                        }
                        if (showStatusBool) {
                            statusHistoryPromises.push(this.getBillStatusHistory(bill));
                        } else {
                            statusHistoryPromises.push(() => Promise.resolve());
                        }
                        if (showNotes && this.props.login.userProfile.email === userCreated) {
                            if (this.state.selectedNotes === 'all') {
                                this.state.collections.forEach(coll => {
                                    let note = coll.WatchListLegislation.find(leg => leg.LegislationID === bill.LegislationID && leg.Note);
                                    if (note) {
                                        bill.Notes.push({ ...note, ListName: coll.Name });
                                    }
                                });
                            }
                            if (this.state.selectedNotes === 'current') {
                                this.state.collections.forEach(coll => {
                                    if (coll.WatchListID === selectedCollection) {
                                        let note = coll.WatchListLegislation.find(leg => leg.LegislationID === bill.LegislationID && leg.Note);
                                        if (note) {
                                            bill.Notes.push({ ...note, ListName: coll.Name });
                                        }
                                    }
                                });
                            }
                        } else if (sharedNotes) {
                            notes.filter(x => x.LegislationID === bill.LegislationID).forEach(note => {
                                bill.Notes.push(note)
                            })
                        }
                        if (showHistory || showCommitteeEventBool) {
                            if (!billHistoryChunks[0] || billHistoryChunks[billHistoryChunks.length - 1].length >= MAX_BILL_HISTORY_CHUNK_SIZE) {
                                billHistoryChunks.push([bill]);
                            } else if (billHistoryChunks[billHistoryChunks.length - 1].length < MAX_BILL_HISTORY_CHUNK_SIZE) {
                                billHistoryChunks[billHistoryChunks.length - 1].push(bill);
                            }
                        }
                        if (showHouseAmendments || showSenateAmendments || showConferenceAmendments || showGovernorsRecommendations) {
                            textPromises.push(this.getAmendments(bill));
                        } else if (showLdNumber) {
                            textPromises.push(this.getLdNumber(bill))
                        } else {
                            textPromises.push(() => Promise.resolve());
                        }
                        this.setState({ billData });
                    });
                    if (billHistoryChunks.length) {
                        billHistoryChunks.forEach(chunk => historyPromises.push(this.getBillHistory(chunk)))
                    } else {
                        historyPromises.push(() => Promise.resolve());
                    }
                    Promise.all(committeePromises).then(() => this.setState({ gettingClerkNames: false, gettingStaffNames: false }));
                    Promise.all(patronPromises).then(() => this.setState({ gettingPatrons: false }));
                    Promise.all(historyPromises).then(() => this.setState({ gettingBillHistory: false, gettingVotes: false }));
                    Promise.all(textPromises).then(() => this.setState({ gettingAmendments: false, gettingLdNumbers: false }));
                    Promise.all(statusHistoryPromises).then(() => this.setState({ gettingBillStatusHistory: false }));

                    Promise.all(committeePromises.concat(patronPromises).concat(historyPromises).concat(textPromises).concat(statusHistoryPromises)).then(() => {
                        this.setState({ generatingReport: false })
                    }).catch((e) => {
                        console.log(e);
                        this.setState({ generatingReport: false })
                    })
                });
            });
        }).catch(err => {
            this.setState({
                reportError: err.toString(),
                generatingReport: false,
                generatingBillNumbers: false
            });
        });
    }

    makePrintout() {
        let printWindow = this.printOutRef.current;
        const pageStyles = document.querySelectorAll("style, link[rel='stylesheet']");
        pageStyles.forEach(el => {
            printWindow.contentDocument.head.appendChild(el.cloneNode(true));
        });
        const reportDataNode = ReactDOM.findDOMNode(this.reportData.current);
        const contentData = reportDataNode.outerHTML;
        const parentDiv = document.createElement('div');
        parentDiv.className = 'search-report-container';
        parentDiv.innerHTML = contentData;
        const title = this.state.reportTitle || this.props.collection.collection[0]?.Name;
        if (title) {
            const header = document.createElement('h2');
            header.textContent = title;
            header.style.margin = '0 0 5px';
            parentDiv.insertBefore(header, parentDiv.childNodes[0]);
        }
        printWindow.contentDocument.body.innerHTML = parentDiv.outerHTML;
        printWindow.focus();
        // timeout is because some browsers do not set the content of the document in time. Since there is no way to check when it is actually finished this 10 millisecond timeout should do the trick.
        setTimeout(() => printWindow.contentWindow.print(), 10);
    }

    makeHtml() {
        const stylesWeCareAbout = [{
            prop: 'font-size',
            default: '16px'
        }, {
            prop: 'font-weight',
            default: '400'
        }, {
            prop: 'margin',
            default: 'none'
        }, {
            prop: 'padding',
            default: '0px'
        }, {
            prop: 'font-family',
            default: '"Lato", sans-serif'
        }, {
            prop: 'line-height',
            default: '22.4px'
        }, {
            prop: 'border',
            default: '0px rgb(51, 51, 51)'
        }, {
            prop: 'text-align',
            default: 'start'
        }, {
            prop: 'display',
            default: 'none'
        }, {
            prop: 'grid-template-columns',
            default: 'none'
        }, {
            prop: 'grid-template-rows',
            default: 'none'
        }, {
            prop: 'box-sizing',
            default: 'border-box'
        }, {
            prop: 'text-indent',
            default: '0px'
        }];
        const htmlRefNode = ReactDOM.findDOMNode(this.htmlRef.current);
        let x = htmlRefNode.querySelectorAll('a');
        x.forEach(el => {
            el.setAttribute('href', el.href);
        })
        let breaks = htmlRefNode.querySelectorAll('hr');
        [...breaks].forEach(b => {
            b.parentNode.removeChild(b);
        });
        const fileName = `Search Results ${moment().tz('America/New_York').format("MM_DD_YYYY HH mm")}.html`
        const targetHTML = document.createElement('div');
        targetHTML.innerHTML = htmlRefNode.innerHTML;
        targetHTML.style.display = 'none';
        const title = this.state.reportTitle || this.props.collection.collection[0]?.Name;
        if (title) {
            const header = document.createElement('h2');
            header.textContent = title;
            header.style.margin = '0 0 5px';
            targetHTML.insertBefore(header, targetHTML.childNodes[0]);
        }
        document.body.appendChild(targetHTML)
        const walker = document.createTreeWalker(targetHTML);
        while (walker.nextNode()) {
            const node = walker.currentNode;
            if (node.nodeName !== '#text') {
                const styles = window.getComputedStyle(node);
                stylesWeCareAbout.forEach(style => {
                    const val = styles.getPropertyValue(style.prop);
                    if (val && val !== style.default) {
                        node.style.setProperty(style.prop, val);
                    }
                })
            }
        }
        saveAs(new Blob([targetHTML.innerHTML], { type: "text/html" }), fileName);
        targetHTML.remove();
    }

    toggleShareForm() {
        this.setState(state => ({
            showShareForm: !state.showShareForm
        }));
    }

    toggleTooltip() {
        this.setState({
            showTooltip: !this.state.showTooltip
        })
    }

    toggleShowNotes() {
        this.setState({
            showNotes: !this.state.showNotes
        })
    }

    componentDidMount() {
        const reportId = this.props.match.params.id;
        if (reportId) {
            this.props.actions.getBillReportInformation('?ReportNumber=' + reportId).then(() => {
                const billReportInformation = this.props.report.billReportInformation;
                if (billReportInformation && billReportInformation.BillInformation) {
                    try {
                        const json = JSON.parse(window.atob(billReportInformation.BillInformation));
                        this.setState({
                            ...json
                        }, () => {
                            if (this.state.billList.length > 0) {
                                this.getReportData();
                            }
                            if (this.state.selectedCollection) {
                                this.props.actions.getCollection("?WatchListID=" + this.state.selectedCollection);
                            }
                        });
                    } catch {
                        console.error("Malformed url");
                        this.setState({ generatingReport: false });
                    }
                } else {
                    console.log("Request succeeded, but no report information found.");
                    this.setState({ reportError: "This report does not exist or the link has expired.", generatingReport: false, generatingBillNumbers: false })
                }
            }).catch(err => {
                if (err === 'Aborted') {
                    return;
                }
                console.log(err);
                this.setState({ reportError: "This report does not exist or the link has expired.", generatingReport: false, generatingBillNumbers: false })
            })
        } else {
            console.log("No Report ID found to use.");
        }
    }

    getBillHistoryTypeLabel = (type) => {
        switch (type) {
            case 'all':
                return `All Events`;
            case 'recent':
                return this.state.showHistory.mostRecentAmount > 1 ? `${this.state.showHistory.mostRecentAmount} Last Events` : 'Last Event';
            case 'Committee':
                return `Last Committee Event`;
            case 'Subcommittee':
                return `Last Subcommittee Event`;
        }
        return;
    }

    async generateXLSX(willBeCSV) {
        const workbook = new Excel.Workbook();
        const { showCatchline, showCurrentStatus, showTitle, showChiefPatron, showAllPatrons, showSummary, showNotes, showHistory, showHouseAmendments, showSenateAmendments, showConferenceAmendments, showGovernorsRecommendations, showStatus, showCommitteeEvent, billData } = this.state;
        let headers = [
            { header: 'Bill', key: 'Billno' },
        ];

        // Only for ease of hiding
        const generateHeaders = (showCatchline, showCurrentStatus, showTitle, showChiefPatron, showAllPatrons, showSummary,
            showNotes, showHistory, showHouseAmendments, showSenateAmendments, showConferenceAmendments, showGovernorsRecommendations,
            showStatus, showCommitteeEvent) => {
            if (showCatchline) {
                headers.push({
                    header: 'Catch line',
                    key: 'Description',
                });
            }
            if (showCurrentStatus) {
                headers.push({
                    header: 'Legislation Status',
                    key: 'LegislationStatus',
                });
            }
            if (showTitle) {
                headers.push({
                    header: 'Legislation Title',
                    key: 'LegislationTitle',
                    formatter: (bill) =>
                        stripTags(bill["LegislationTitle"])

                });
            }
            if (showSummary) {
                headers.push({
                    header: 'Legislation Summary',
                    key: 'LegislationSummary',
                    formatter: (bill) =>
                        stripTags(bill["LegislationSummary"])
                });
            }
            if (showChiefPatron) {
                headers.push({
                    header: 'Chief Patron',
                    key: 'ChiefPatron',
                    formatter: (bill) =>
                        bill.Patrons ? bill.Patrons.filter(p => p.Name === 'Chief Patron').map(patron => patron.PatronDisplayName).join(', ') : ''
                });
            }
            if (showAllPatrons) {
                headers.push({
                    header: "All Patrons",
                    key: "AllPatrons",
                    formatter: (bill) => {
                        return (bill.Patrons ? bill.Patrons.map(patron => {
                            let formattedName = patron.PatronDisplayName
                            if (patron.Name === 'Chief Patron') {
                                formattedName += ' ' + patron.DisplayName;
                            }
                            return formattedName;
                        }) : []).join(', ');
                    }
                });
            }
            if (showStatus.showEmergency) {
                headers.push({
                    header: "Emergency",
                    key: "Emergency",
                    formatter: (bill) =>
                        bill.EffectiveType === 'Emergency' ? "Y" : "N"
                });
            }
            if (showStatus.showPassedHouse) {
                headers.push({
                    header: "Passed House",
                    key: "PassedHouse",
                    formatter: (bill) =>
                        bill.billStatuses.PassedHouse
                });
            }
            if (showStatus.showPassedSenate) {
                headers.push({
                    header: "Passed Senate",
                    key: "PassedSenate",
                    formatter: (bill) =>
                        bill.billStatuses.PassedSenate
                });
            }
            if (showStatus.showPassed) {
                headers.push({
                    header: "Passed",
                    key: "Passed",
                    formatter: (bill) =>
                        bill.billStatuses.Passed
                });
            }
            if (showStatus.showFailed) {
                headers.push({
                    header: "Failed",
                    key: "Failed",
                    formatter: (bill) =>
                        bill.billStatuses.Failed
                });
            }
            if (showStatus.showContinued) {
                headers.push({
                    header: "Continued",
                    key: "Continued",
                    formatter: (bill) =>
                        bill.billStatuses.Continued
                });
            }
            if (showStatus.showApproved) {
                headers.push({
                    header: "Approved",
                    key: "Approved",
                    formatter: (bill) =>
                        bill.billStatuses.Approved
                });
            }
            if (showStatus.showVetoed) {
                headers.push({
                    header: "Vetoed",
                    key: "Vetoed",
                    formatter: (bill) =>
                        bill.billStatuses.Vetoed
                });
            }
            const getFirstCommitteeEventString = e =>
                `${moment(e.EventDate).tz('America/New_York').format("MM/DD/YY")} ${e.ActorType} ${e.Description}`;

            if (showCommitteeEvent.showFirstHouseCommittee) {
                headers.push({
                    header: "1st House com",
                    key: "1stHousecom",
                    formatter: (bill) =>
                        bill.committeeEvents.firstHouseCommitteeEvent ? getFirstCommitteeEventString(bill.committeeEvents.firstHouseCommitteeEvent) : ""
                })
            }
            if (showCommitteeEvent.showFirstSenateCommittee) {
                headers.push({
                    header: "1st Senate com",
                    key: "1stSenatecom",
                    formatter: (bill) =>
                        bill.committeeEvents.firstSenateCommitteeEvent ? getFirstCommitteeEventString(bill.committeeEvents.firstSenateCommitteeEvent) : ""
                })
            }
            if (showCommitteeEvent.showLastHouseSubcommittee) {
                headers.push({
                    header: "Last House Subcommittee Assigned",
                    key: "LastHouseSubcommitteeAssigned",
                    formatter: (bill) =>
                        bill.committeeEvents.lastHouseSubcommitteeEvent ? bill.committeeEvents.lastHouseSubcommitteeEvent.Description : ""
                })
            }
            if (showCommitteeEvent.showLastSenateSubcommittee) {
                headers.push({
                    header: "Last Senate Subcommittee Assigned",
                    key: "LastSenateSubcommitteeAssigned",
                    formatter: (bill) =>
                        bill.committeeEvents.lastSenateSubcommitteeEvent ? bill.committeeEvents.lastSenateSubcommitteeEvent.Description : ""
                })
            }
            if (showNotes) {
                let noteMax = 0;
                billData.forEach(bill => {
                    if (bill.Notes.length > noteMax) {
                        noteMax = bill.Notes.length;
                    }
                });
                if (noteMax > 0) {
                    for (let i = 1; i <= noteMax; i++) {
                        headers.push({
                            header: `Note ${i}`,
                            key: `Note ${i}`,
                            formatter: (bill) =>
                                i <= bill.Notes.length ? `${bill.Notes[i - 1].ListName}\n${bill.Notes[i - 1].Note}` : '',
                            width: 32
                        });
                    }
                }
            }
            if (showHistory.Committee) {
                headers.push({
                    header: 'Last Committee Event',
                    key: 'LastCommitteeEvent',
                    formatter: (bill) =>
                        (bill.billHistory.Committee ?? []).length > 0 ? bill.billHistory.Committee[0].Description : ''
                });
                headers.push({
                    header: 'Last Committee Event Date',
                    key: 'LastCommitteeEventDate',
                    formatter: (bill) =>
                        (bill.billHistory.Committee ?? []).length > 0 ? moment(bill.billHistory.Committee[0].EventDate).format("MM/DD/YYYY") : ''
                });
            }
            if (showHistory.Subcommittee) {
                headers.push({
                    header: 'Last Subcommittee Event',
                    key: 'LastSubcommitteeEvent',
                    formatter: (bill) =>
                        (bill.billHistory.Subcommittee ?? []).length > 0 ? bill.billHistory.Subcommittee[0]?.Description : ''
                });
                headers.push({
                    header: 'Last Subcommittee Event Date',
                    key: 'LastSubcommitteeEventDate',
                    formatter: (bill) =>
                        (bill.billHistory.Subcommittee ?? []).length > 0 ? moment(bill.billHistory.Subcommittee[0].EventDate).format("MM/DD/YYYY") : ''
                });
            }
            if ((showHistory.Committee || showHistory.Subcommittee) && showHistory.showVotes) {
                const mapBill = (bill) =>
                    Object.entries(bill.billHistory ?? []).toSorted(([typeA, itemsA], [typeB, itemsB]) => sortBillHistoryTypes(typeA, typeB)).map(([billHistoryType, billHistoryItems]) => billHistoryItems);

                headers.push({
                    header: 'YEAS',
                    key: 'YEAS',
                    formatter: (bill) => {
                        Object.entries(bill.billHistory ?? []).toSorted(([typeA, itemsA], [typeB, itemsB]) => sortBillHistoryTypes(typeA, typeB)).map(([billHistoryType, billHistoryItems]) => billHistoryItems);
                        const historyItem = mapBill(bill).toReversed()[0];
                        return historyItem.voteDetails ? genPatronList(historyItem.voteDetails.memberYeas) : '';
                    }
                }, {
                    header: 'NAYS',
                    key: 'NAYS',
                    formatter: (bill) => {
                        const historyItem = mapBill(bill).toReversed()[0];
                        return historyItem.voteDetails ? genPatronList(historyItem.voteDetails.memberNays) : '';
                    }
                }, {
                    header: 'NOT VOTING',
                    key: 'NOTVOTING',
                    formatter: (bill) => {
                        const historyItem = mapBill(bill).toReversed()[0];
                        return historyItem.voteDetails ? genPatronList(historyItem.voteDetails.memberNoVote) : '';
                    }
                }, {
                    header: 'ABSTENTIONS',
                    key: 'ABSTENTIONS',
                    formatter: (bill) => {
                        const historyItem = mapBill(bill).toReversed()[0];
                        return historyItem.voteDetails ? genPatronList(historyItem.voteDetails.memberAbstentions) : '';
                    }
                }, {
                    header: 'RULE 36',
                    key: 'RULE36',
                    formatter: (bill) => {
                        const historyItem = mapBill(bill).toReversed()[0];
                        return historyItem.voteDetails ? genPatronList(historyItem.voteDetails.memberRule36) : '';
                    }
                });
            }
            if (showHistory.recent && showHistory.mostRecentAmount < 2) {
                headers.push({
                    header: 'Last Event',
                    key: 'LastEvent',
                    formatter: (bill) =>
                        (bill.billHistory.recent ?? []).length > 0 ? getFirstCommitteeEventString(bill.billHistory.recent[0]) : ''
                })
            }
            // if (!willBeCSV) {
            //     if (showHouseAmendments || showSenateAmendments || showConferenceAmendments || showGovernorsRecommendations) {
            //         let amendmentMax = 0;
            //         billData.forEach(bill => {
            //             if (bill.amendments.length > amendmentMax) {
            //                 amendmentMax = bill.amendments.length;
            //             }
            //         });
            //         if (amendmentMax > 0) {
            //             for (let i = 1; i <= amendmentMax; i++) {
            //                 headers.push({
            //                     header: `Amendment ${i}`,
            //                     key: `Amendment ${i}`,
            //                     formatter: (bill) =>
            //                         i <= bill.amendments.length ? stripTags(bill.amendments[i - 1].DraftText) : '',
            //                     width: 32
            //                 });
            //             }
            //         }
            //     }
            // }
        }
        generateHeaders(showCatchline, showCurrentStatus, showTitle, showChiefPatron, showAllPatrons, showSummary, showNotes, showHistory, showHouseAmendments, showSenateAmendments, showConferenceAmendments, showGovernorsRecommendations, showStatus, showCommitteeEvent);

        // History sheet isn't always generated
        const includeHistory = showHistory.all || (showHistory.recent && showHistory.mostRecentAmount > 1);
        const historyHeaders = includeHistory ? [{
            header: 'Bill',
            key: 'Billno'
        }, {
            header: 'Date',
            key: 'Date',
            formatter: (historyItem) =>
                moment(historyItem.EventDate).tz('America/New_York').format('MM/DD/YYYY')
        }, {
            header: 'Body',
            key: 'ActorType'
        }, {
            header: 'Description',
            key: 'Description'
        }] : [];
        if (includeHistory) {
            const genPatronList = (patronArray) => patronArray.map(item => item.PatronDisplayName).join(', ');
            if (showHistory.showVotes) {
                historyHeaders.push({
                    header: 'YEAS',
                    key: 'YEAS',
                    formatter: (historyItem) =>
                        historyItem.voteDetails ? genPatronList(historyItem.voteDetails.memberYeas) : ''
                }, {
                    header: 'NAYS',
                    key: 'NAYS',
                    formatter: (historyItem) =>
                        historyItem.voteDetails ? genPatronList(historyItem.voteDetails.memberNays) : ''
                }, {
                    header: 'NOT VOTING',
                    key: 'NOTVOTING',
                    formatter: (historyItem) =>
                        historyItem.voteDetails ? genPatronList(historyItem.voteDetails.memberNoVote) : ''
                }, {
                    header: 'ABSTENTIONS',
                    key: 'ABSTENTIONS',
                    formatter: (historyItem) =>
                        historyItem.voteDetails ? genPatronList(historyItem.voteDetails.memberAbstentions) : ''
                }, {
                    header: 'RULE 36',
                    key: 'RULE36',
                    formatter: (historyItem) =>
                        historyItem.voteDetails ? genPatronList(historyItem.voteDetails.memberRule36) : ''
                });
            }
        }

        let historyRows = [];
        const newRows = [];
        billData.forEach(bill => {
            const row = {};
            headers.forEach(header => {
                if (header.key === 'Billno') {
                    row['Billno'] = {
                        text: bill['LegislationNumber'],
                        hyperlink: `${window.location.origin}/bill-details/${bill["SessionCode"]}/${bill["LegislationNumber"]}`
                    };
                } else if (header.formatter) {
                    row[header.key] = header.formatter(bill);
                } else {
                    row[header.key] = bill[header.key] || '';
                }
            });
            newRows.push(row)
            if (includeHistory) {
                let theseHistoryRows = [];
                Object.entries(bill.billHistory).toSorted(([typeA, itemsA], [typeB, itemsB]) => sortBillHistoryTypes(typeA, typeB)).map(([billHistoryType, billHistoryItems]) => {
                    if (billHistoryType === 'all' || (billHistoryType === 'recent' && showHistory.mostRecentAmount > 1)) {
                        billHistoryItems.map(historyItem => {
                            const thisHistoryRow = {};
                            historyHeaders.forEach(header => {
                                if (header.key === 'Billno') {
                                    thisHistoryRow['Billno'] = {
                                        text: bill['LegislationNumber'],
                                        hyperlink: `${window.location.origin}/bill-details/${bill["SessionCode"]}/${bill["LegislationNumber"]}`
                                    };
                                } else if (header.formatter) {
                                    thisHistoryRow[header.key] = header.formatter(historyItem);
                                } else {
                                    thisHistoryRow[header.key] = historyItem[header.key] || '';
                                }
                            });
                            theseHistoryRows.push(thisHistoryRow);
                        });
                    }
                });
                historyRows = historyRows.concat(theseHistoryRows);
            }
        })

        workbook.addWorksheet('Bill Report');
        const sheet = workbook.worksheets[0];
        sheet.columns = headers;
        newRows.forEach(bill => sheet.addRow(bill));
        workbook.worksheets.forEach(sheet => {
            sheet._columns.forEach(column => { // I like how you have to set some of these here, and the others in the column definitions. I know wrap can be cell by cell, rather than column width but come on.
                if (column._key?.includes('Note') || column.key?.includes('Amendment')) {
                    column.alignment = { wrapText: true };
                } else {
                    column.alignment = { vertical: 'top' }
                }
            });
            workbook.worksheets.forEach(sheet => {
                sheet.eachRow(row => {
                    row.eachCell(cell => {
                        if (!!cell?._value?.model?.hyperlink) {
                            let linkColor = '2875B8'; //a11y later
                            cell.font = {
                                color: {
                                    argb: `FF${linkColor}`
                                },
                                underline: true
                            };
                        }
                    });
                });
            });
        });
        if (includeHistory) {
            workbook.addWorksheet('Bill History');
            const historySheet = workbook.worksheets[1];
            historySheet.columns = historyHeaders;
            historyRows.forEach(historyItem => {
                historySheet.addRow(historyItem)
            });
            historySheet.eachRow(row => {
                row.eachCell(cell => {
                    if (!!cell?._value?.model?.hyperlink) {
                        let linkColor = '2875B8'; //a11y later
                        cell.font = {
                            color: {
                                argb: `FF${linkColor}`
                            },
                            underline: true
                        };
                    }
                });
            });
        }
        if (willBeCSV) {
            const options = {
                map(value, index) {
                    if (value?.hyperlink) {
                        return `=HYPERLINK("${value.hyperlink}","${value.text}")`;
                    }
                    return value.text ?? value;
                },
            }
            await workbook.csv.writeBuffer(options).then((buffer) => {
                const a = document.createElement('a');
                const data = new Blob([buffer], { type: "data:text/csv;charset=utf-8," });
                const url = window.URL.createObjectURL(data);
                a.href = url;
                a.download = `Search Results ${moment().tz('America/New_York').format("MM_DD_YYYY HH mm")}.csv`
                a.click();
                setTimeout(() => {
                    a.remove();
                    window.URL.revokeObjectURL(url);
                });
            }).catch((error) => {
                console.error('Error writing excel file:', error);
            });
            options.sheetName = 'Bill History'
            await workbook.csv.writeBuffer(options).then((buffer) => {
                const a = document.createElement('a');
                const data = new Blob([buffer], { type: "data:text/csv;charset=utf-8," });
                const url = window.URL.createObjectURL(data);
                a.href = url;
                a.download = `Bill History${moment().tz('America/New_York').format("MM_DD_YYYY HH mm")}.csv`
                a.click();
                setTimeout(() => {
                    a.remove();
                    window.URL.revokeObjectURL(url);
                });
            }).catch((error) => {
                console.error('Error writing excel file:', error);
            });
        } else {
            const fileName = `Search Results ${moment().tz('America/New_York').format("MM_DD_YYYY HH mm")}.xlsx`
            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                saveAs(blob, fileName);
            });
        }
    }

    render() {
        const { billData, reportError, generatingBillNumbers, generatingReport, gettingCommittees, gettingPatrons, gettingAmendments, gettingBillHistory, gettingVotes, gettingLdNumbers, gettingClerkNames, gettingStaffNames, showCatchline, showCurrentStatus, showTitle, showChiefPatron, showAllPatrons, showSummary, showNotes, showHistory, showHouseAmendments, showSenateAmendments, showConferenceAmendments, showGovernorsRecommendations, showStatus, showCommitteeEvent, showLdNumber, showClerkNames, showDlsStaffNames, sbCount, sjCount, hbCount, hjCount, userCreated } = this.state;
        const sortBillsNumerically = (a, b, direction) => {
            if (direction === "asc") {
                return a.LegislationNumber.substring(0, 2).localeCompare(b.LegislationNumber.substring(0, 2)) === 0
                    ? a.LegislationKey - b.LegislationKey
                    : a.LegislationNumber.substring(0, 2).localeCompare(b.LegislationNumber.substring(0, 2)) > 0
                        ? 1
                        : -1
            } else {
                return a.LegislationNumber.substring(0, 2).localeCompare(b.LegislationNumber.substring(0, 2)) === 0
                    ? b.LegislationKey - a.LegislationKey
                    : a.LegislationNumber.substring(0, 2).localeCompare(b.LegislationNumber.substring(0, 2)) > 0
                        ? -1
                        : 1
            }
        }

        if (generatingBillNumbers) {
            return (
                <div className="small-text">
                    {reportError && <div>{reportError}</div>}
                    <div>Getting Bill Data <span className="small-spinner"></span></div>
                </div>)
        }
        const shareable = this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR)
            && userCreated === this.props.login.userProfile.email;
        return (<div>
            <div>
                {this.state.showTooltip &&
                    <CsvHelpModal closeModal={() => this.toggleTooltip(false)} />
                }
                {this.state.showShareForm && !reportError &&
                    <ShareReport
                        toggleShareForm={this.toggleShareForm}
                        emailSubject={this.state.reportTitle || this.props.collection.collection[0]?.Name || `Custom Legislation Report ${moment().tz('America/New_York').format('M/D/YYYY')}`}
                        source={('reports-' + (this.state.billData.filter(b => b.Notes?.length > 0).length > 0) + '')}
                    />
                }
                <div className="advanced-search dlas-forms search-report-container">
                    {!reportError &&
                        <div className="flex-row" style={{ borderBottom: '1px solid #ccc' }}>
                            {this.state.reportTitle || this.props.collection.collection != "" ?
                                <div>
                                    <h2 style={{ margin: 0, lineHeight: '16px' }}>{this.state.reportTitle || this.props.collection.collection[0].Name}</h2>
                                </div>
                                : <br />
                            }
                            <div className="inline-list report-icon-holder" style={{ textAlign: 'right' }}>
                                {generatingReport ? <div className="small-text center">Getting Data <span className="small-spinner"></span></div>
                                    : <React.Fragment>
                                        {shareable &&
                                            <button disabled={generatingReport} onClick={this.toggleShareForm} type="button" className="button share-report">Share <span className='icon share' /></button>
                                        }
                                        <span aria-label="print" title="print" onClick={this.makePrintout} className={`icon print${generatingReport ? ' disabled' : ''} `}></span>
                                        <span aria-label="spreadsheet" title="spreadsheet" onClick={() => this.generateXLSX(false)} className={`icon csv${generatingReport ? ' disabled' : ''} `}></span>
                                        <span aria-label="html" title="html" onClick={this.makeHtml} className={`icon paper${generatingReport ? ' disabled' : ''} `}></span>
                                        <a onClick={e => { e.stopPropagation(); this.generateXLSX(true) }} style={{ cursor: "pointer" }}>CSV</a>
                                        <a className='button info' onClick={(e) => { e.stopPropagation(e); this.toggleTooltip() }} style={{ cursor: "pointer" }}>?</a>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    }
                    <div ref={this.htmlRef}>
                        <div className="small-text">
                            {reportError && <div>{reportError}</div>}
                        </div>
                        <div ref={this.reportData} className="report-container report">
                            {this.state.personalMessage && <h3 style={{ lineBreak: "anywhere" }}>{this.state.personalMessage}</h3>}
                            {billData.map((bill, i) =>
                                <div key={i} className='report-bill' style={{ display: 'block', marginBottom: '10px', paddingBottom: '10px' }}>
                                    <h3><Link className='report-link' to={`/bill-details/${bill.SessionCode}/${bill.LegislationNumber}`}>{bill.LegislationNumber.split(/(\d+)/).join(" ")}</Link > {showCatchline && ` - ${bill.Description}`
                                    }</h3 >
                                    {
                                        showChiefPatron || showAllPatrons ?
                                            (bill.loadingPatrons ?
                                                <div style={{ margin: '0.3em 0px' }}>Getting Patrons <span className="small-spinner"></span></div>
                                                :
                                                <>
                                                    {showChiefPatron && bill['Chief Patron'] && <article>
                                                        <h4 className='label'>Chief Patron{bill['Chief Patron'].length > 1 && "s"}:</h4> {bill['Chief Patron'].map((patron, patronIndex) => <p className='content inline' key={patronIndex}>
                                                            {patronIndex !== 0 && ', '}{patron.PatronDisplayName}
                                                        </p>)}</article>
                                                    }
                                                    {showAllPatrons && <article>
                                                        <h4 className='label'>Patron{bill.Patrons.length > 1 && "s"}:</h4> {bill.Patrons.map((patron, patronIndex) => <p className='content inline' key={patronIndex}>
                                                            {patronIndex !== 0 && ', '}{patron.PatronDisplayName}
                                                        </p>)}</article>
                                                    }
                                                </>)
                                            : null
                                    }
                                    {showCurrentStatus && <article><h4 className='label'>Status: </h4><p className='content inline'>{bill.LegislationStatus}</p></article>}
                                    {showTitle && bill.LegislationTitle && <article className='title'>
                                        <h4>Title</h4>
                                        {renderHTML(bill.LegislationTitle)}
                                    </article>
                                    }
                                    {
                                        showClerkNames && bill.CommitteeID && bill.SessionID &&
                                            bill.loadingClerkNames || (!this.state.committeeClerksAndStaff.find(c => c.AffiliationID === bill.CommitteeID && c.SessionID === bill.SessionID && c.StaffRoleTypeID === this.state.clerkRoleTypeID) && gettingClerkNames) ?
                                            <div style={{ margin: '0.3em 0px' }}>Getting clerk(s) of current committee <span className="small-spinner"></span></div>
                                            :
                                            this.state.committeeClerksAndStaff.find(c => c.AffiliationID === bill.CommitteeID && c.SessionID === bill.SessionID && c.StaffRoleTypeID === this.state.clerkRoleTypeID) ?
                                                <article className='dls'>
                                                    <h4>Clerk{this.state.committeeClerksAndStaff.filter(c => c.AffiliationID === bill.CommitteeID && c.SessionID === bill.SessionID && c.StaffRoleTypeID === this.state.clerkRoleTypeID).length > 1 ? 's' : ''} of current committee:</h4>&nbsp;
                                                    {
                                                        this.state.committeeClerksAndStaff.filter(c => c.AffiliationID === bill.CommitteeID && c.SessionID === bill.SessionID && c.StaffRoleTypeID === this.state.clerkRoleTypeID).map((m, i) =>
                                                            <span>{m.FullName}{i === this.state.committeeClerksAndStaff.filter(c => c.AffiliationID === bill.CommitteeID && c.SessionID === bill.SessionID && c.StaffRoleTypeID === this.state.clerkRoleTypeID).length - 1 ? '' : ', '}</span>
                                                        )
                                                    }
                                                </article>
                                                : null
                                    }
                                    {
                                        showDlsStaffNames && bill.CommitteeID && bill.SessionID &&
                                            bill.loadingStaffNames || (!this.state.committeeClerksAndStaff.find(c => c.AffiliationID === bill.CommitteeID && c.SessionID === bill.SessionID && c.StaffRoleTypeID === this.state.staffRoleTypeID) && gettingStaffNames) ?
                                            <div style={{ margin: '0.3em 0px' }}>Getting DLS staff of current committee <span className="small-spinner"></span></div>
                                            :
                                            this.state.committeeClerksAndStaff.find(c => c.AffiliationID === bill.CommitteeID && c.SessionID === bill.SessionID && c.StaffRoleTypeID === this.state.staffRoleTypeID) ?
                                                <article className='dls'>
                                                    <h4>DLS staff of current committee:</h4>&nbsp;
                                                    {
                                                        this.state.committeeClerksAndStaff.filter(c => c.AffiliationID === bill.CommitteeID && c.SessionID === bill.SessionID && c.StaffRoleTypeID === this.state.staffRoleTypeID).map((m, i) =>
                                                            <span key={i}>{m.FullName}{i === this.state.committeeClerksAndStaff.filter(c => c.AffiliationID === bill.CommitteeID && c.SessionID === bill.SessionID && c.StaffRoleTypeID === this.state.staffRoleTypeID).length - 1 ? '' : ', '}</span>
                                                        )
                                                    }
                                                </article>
                                                : null
                                    }
                                    {
                                        showLdNumber &&
                                            bill.loadingLdNumber || (!bill.LdNumber && gettingLdNumbers) ?
                                            <div style={{ margin: '0.3em 0px' }}>Getting LD Number of current version <span className="small-spinner"></span></div>
                                            :
                                            bill.LdNumber ?
                                                <article className='dls'>
                                                    <h4>LD Number of current version:</h4> {bill.LdNumber}
                                                </article>
                                                : null
                                    }
                                    {
                                        showNotes && bill.Notes && bill.Notes.length > 0 &&
                                        <article className='notes'>
                                            <h4>Notes</h4>
                                            {bill.Notes.map((note, noteIndex) =>
                                                <div key={noteIndex}>
                                                    <span>{`${note.ListName}:\u00a0`}</span>{note.Note}
                                                </div>
                                            )}
                                        </article>
                                    }
                                    {
                                        showSummary &&
                                        <article className='summary'>
                                            <h4>{bill.SummaryVersion}</h4>{renderHTML(bill.LegislationSummary)}
                                        </article>
                                    }
                                    {
                                        (showHouseAmendments || showSenateAmendments || showConferenceAmendments || showGovernorsRecommendations) && (
                                            bill.loadingAmendments ?
                                                <div style={{ margin: '0.3em 0px' }}>Getting Amendment Text <span className="small-spinner"></span></div>
                                                :
                                                bill.amendments && bill.amendments.length ?
                                                    <article>
                                                        <h4>{`Amendment${bill.amendments.length > 1 ? 's' : ''}`}</h4>
                                                        {bill.amendments.map((amendment, amendmentIndex) =>
                                                            <div key={amendmentIndex}>
                                                                <strong>{amendment.Description}</strong>
                                                                {amendment.DraftText ? renderHTML(amendment.DraftText
                                                                    .replaceAll('<p class=textbl>&nbsp;</p>', '').replaceAll('<p class=textbl> </p>', '').replaceAll('<p class=textbl></p>', '').replaceAll('<p class=textbl>\u200B</p>', '').replaceAll('<p class=textbl>\u00a0</p>', '')
                                                                    .replaceAll('<p class=section>&nbsp;</p>', '').replaceAll('<p class=section> </p>', '').replaceAll('<p class=section></p>', '').replaceAll('<p class=section>\u200B</p>', '').replaceAll('<p class=section>\u00a0</p>', '')
                                                                    .replaceAll('<p class=i0>&nbsp;</p>', '').replaceAll('<p class=i0> </p>', '').replaceAll('<p class=i0></p>', '').replaceAll('<p class=i0>\u200B</p>', '').replaceAll('<p class=i0>\u00a0</p>', '')
                                                                    .replaceAll('<p class="textbl">&nbsp;</p>', '').replaceAll('<p class="textbl"> </p>', '').replaceAll('<p class="textbl"></p>', '').replaceAll('<p class="textbl">\u200B</p>', '').replaceAll('<p class="textbl">\u00a0</p>', '')
                                                                    .replaceAll('<p class="section">&nbsp;</p>', '').replaceAll('<p class="section"> </p>', '').replaceAll('<p class="section"></p>', '').replaceAll('<p class="section">\u200B</p>', '').replaceAll('<p class="section">\u00a0</p>', '')
                                                                    .replaceAll('<p class="i0">&nbsp;</p>', '').replaceAll('<p class="i0"> </p>', '').replaceAll('<p class="i0"></p>', '').replaceAll('<p class="i0">\u200B</p>', '').replaceAll('<p class="i0">\u00a0</p>', '')
                                                                    .replaceAll('<p></p>', '').replaceAll('<p> </p>', '').replaceAll('<p>&nbsp;</p>', '').replaceAll('<p>\u200b</p>', '').replaceAll('<p>\u00a0</p>', '')
                                                                ) : <></>}
                                                            </div>
                                                        )}
                                                    </article>
                                                    : null
                                        )
                                    }
                                    {
                                        bill.billStatuses && (
                                            bill.loadingStatusHistory ?
                                                <div style={{ margin: '0.3em 0px' }}>Getting Bill Statuses <span className="small-spinner"></span></div>
                                                :
                                                <article>
                                                    <h4>Bills Statuses</h4>
                                                    <p className="inner-grid four content">
                                                        {showStatus.showPassedHouse && <span>Passed House: {bill.billStatuses.PassedHouse}</span>}
                                                        {showStatus.showPassedSenate && <span>Passed Senate: {bill.billStatuses.PassedSenate}</span>}
                                                        {showStatus.showPassed && <span>Passed: {bill.billStatuses.Passed}</span>}
                                                        {showStatus.showVetoed && <span>Vetoed: {bill.billStatuses.Vetoed}</span>}
                                                        {showStatus.showApproved && <span>Approved: {bill.billStatuses.Approved}</span>}
                                                        {showStatus.showFailed && <span>Failed: {bill.billStatuses.Failed}</span>}
                                                        {showStatus.showContinued && <span>Continued: {bill.billStatuses.Continued}</span>}
                                                        {showStatus.showEmergency && <span>Emergency: {bill.Emergency}</span>}
                                                    </p>
                                                </article>
                                        )
                                    }
                                    {
                                        bill.committeeEvents &&
                                        <>
                                            {showCommitteeEvent.showFirstHouseCommittee && bill.committeeEvents.firstHouseCommitteeEvent && <article><h4 className='label'>First House Committee Referred:</h4> {bill.committeeEvents.firstHouseCommitteeEvent.Description}</article>}
                                            {showCommitteeEvent.showFirstSenateCommittee && bill.committeeEvents.firstSenateCommitteeEvent && <article><h4 className='label'>First Senate Committee Referred:</h4> {bill.committeeEvents.firstSenateCommitteeEvent.Description}</article>}
                                            {showCommitteeEvent.showLastHouseSubcommittee && bill.committeeEvents.lastHouseSubcommitteeEvent && <article><h4 className='label'>Last House Subcommittee Assigned:</h4> {bill.committeeEvents.lastHouseSubcommitteeEvent.Description}</article>}
                                            {showCommitteeEvent.showLastSenateSubcommittee && bill.committeeEvents.lastSenateSubcommitteeEvent && <article><h4 className='label'>Last Senate Subcommittee Assigned:</h4> {bill.committeeEvents.lastSenateSubcommitteeEvent.Description}</article>}
                                        </>
                                    }
                                    {
                                        showHistory && (
                                            bill.loadingHistory ?
                                                <div key={bill.LegislationID + !!bill.loadingHistory} style={{ margin: '0.3em 0px' }}>{"Getting Bill Events" + (showHistory.showVotes ? " and Vote Data" : "")} <span className="small-spinner"></span></div>
                                                :
                                                bill.billHistory &&
                                                //Move grid container div inti place of react fragment to create a new grid for each row instead of continuing to overfill the parent div
                                                <div key={bill.LegislationID + !!bill.loadingHistory} >
                                                    {Object.entries(bill.billHistory).map(([billHistoryType, billHistoryItems], billHistoryTypeIndex) =>
                                                        <article key={billHistoryTypeIndex}>
                                                            <h4>{this.getBillHistoryTypeLabel(billHistoryType)}</h4>
                                                            <div style={{ display: "grid", gridTemplateColumns: "105px 85px 1fr" }} className="content">
                                                                {billHistoryItems.toReversed().map((billHistoryItem, billHistoryItemIndex) =>
                                                                    <React.Fragment key={billHistoryItemIndex}>
                                                                        <div style={{ marginRight: "12px" }}>
                                                                            {moment(billHistoryItem.EventDate).tz('America/New_York').format('MM/DD/YYYY')}
                                                                        </div>
                                                                        <div style={{ marginRight: "12px" }}>
                                                                            {billHistoryItem.ActorType}
                                                                        </div>
                                                                        <div style={{ marginRight: "12px" }}>
                                                                            {(billHistoryItem?.Description ?? '').replaceAll('-', '‑')}{/*nonbreaking hyphen/*/}
                                                                        </div>
                                                                        {showHistory.showVotes && (
                                                                            billHistoryItem.voteDetails ?
                                                                                <div key={bill.LegislationID + billHistoryItem.LegislationEventID + !!billHistoryItem.voteDetails} style={{ gridColumn: '3 / 4' }}>
                                                                                    <p>
                                                                                        YEAS--
                                                                                        {billHistoryItem.voteDetails.memberYeas.map((item, index) => (
                                                                                            <span key={index}>{item.PatronDisplayName}{billHistoryItem.voteDetails.memberYeas.length === index + 1 ? '--' : ', '}</span>
                                                                                        ))}
                                                                                        {billHistoryItem.voteDetails.memberYeas.length}
                                                                                    </p>
                                                                                    <p>
                                                                                        NAYS--
                                                                                        {billHistoryItem.voteDetails.memberNays.map((item, index) => (
                                                                                            <span key={index}>{item.PatronDisplayName}{billHistoryItem.voteDetails.memberNays.length === index + 1 ? '--' : ', '}</span>
                                                                                        ))}
                                                                                        {billHistoryItem.voteDetails.memberNays.length}
                                                                                    </p>
                                                                                    <p>
                                                                                        {(billHistoryItem.voteDetails.VoteType === "Floor" && billHistoryItem.voteDetails.ChamberCode === "S") ? "RULE 36--" : "ABSTENTIONS--"}
                                                                                        {billHistoryItem.voteDetails.memberAbstentions.map((item, index) => (
                                                                                            <span key={index}>{item.PatronDisplayName}{billHistoryItem.voteDetails.memberAbstentions.length === index + 1 ? '--' : ', '}</span>
                                                                                        ))}
                                                                                        {billHistoryItem.voteDetails.memberAbstentions.length}
                                                                                    </p>
                                                                                    <p>
                                                                                        NOT VOTING--
                                                                                        {billHistoryItem.voteDetails.memberNoVote.map((item, index) => (
                                                                                            <span key={index}>{item.PatronDisplayName}{billHistoryItem.voteDetails.memberNoVote.length === index + 1 ? '--' : ', '}</span>
                                                                                        ))}
                                                                                        {billHistoryItem.voteDetails.memberNoVote.length}
                                                                                    </p>
                                                                                    {(billHistoryItem.voteDetails.VoteType !== "Floor" && billHistoryItem.voteDetails.ChamberCode !== "S") &&
                                                                                        <p>
                                                                                            RULE 36--
                                                                                            {billHistoryItem.voteDetails.memberRule36.map((item, index) => (
                                                                                                <span key={index}>{item.PatronDisplayName}{billHistoryItem.voteDetails.memberRule36.length === index + 1 ? '--' : ', '}</span>
                                                                                            ))}
                                                                                            {billHistoryItem.voteDetails.memberRule36.length}
                                                                                        </p>
                                                                                    }
                                                                                </div>
                                                                                :
                                                                                billHistoryItem.loadingVotes ?
                                                                                    <div key={bill.LegislationID + billHistoryItem.LegislationEventID + !!billHistoryItem.voteDetails} style={{ gridColumn: '3/4', margin: '0.3em 0px' }}>Getting Vote Data <span className="small-spinner"></span></div>
                                                                                    :
                                                                                    null
                                                                        )}
                                                                    </React.Fragment>
                                                                )}
                                                            </div>
                                                        </article>
                                                    )}
                                                </div>
                                        )
                                    }
                                </div >
                            )
                            }
                            {!reportError && <span><b>Counts:</b> {`HB: ${hbCount} HJ: ${hjCount} SB: ${sbCount} SJ: ${sjCount}`}</span>}
                        </div>
                    </div>
                </div>
            </div>
            <iframe aria-hidden="true" ref={this.printOutRef} width="0" height="0" frameBorder="0" src="about:blank"></iframe>
        </div >);
    }
}

export default connect(
    (state) => {
        const { bills, session, members, committee, patrons, nav, login, votes, collection, report, personnel } = state;
        return {
            bills,
            session,
            members,
            committee,
            patrons,
            nav,
            login,
            votes,
            collection,
            report,
            personnel
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, committeeActionCreators, billActionCreators, sessionActionCreators, memberActionCreators, patronActionCreators, voteActionCreators, collectionActionCreators, reportActionCreators, personnelActionCreators), dispatch)
        }
    }
)(ReportMaker);
